import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export const useLoadLoggerForDataDog = (tagNames: string[]): void => {
  useEffect(() => {
    tagNames.forEach((tagName) => {
      try {
        const markerEntry = performance.getEntriesByName(tagName)[0];

        if (markerEntry) {
          const loadMeasure = performance.measure(tagName, tagName);
          const loadTime = Math.floor(loadMeasure.duration);

          datadogRum.addTiming(tagName, loadTime);

          performance.clearMeasures();
          performance.clearMarks();
        }

        // eslint-disable-next-line no-empty
      } catch (error) {}
    });
  }, [tagNames]);
};

export const setMarkerForDataDog = (markerName: string): void => {
  performance.clearMarks();
  performance.mark(markerName);
};
